import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
  isOLG,
} from '../../../../actions/root_url';
import { DateFormatter } from '../../dateFormat';

// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222


export const fetchPromotions = (Company_id, success, failed) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/sale/promotion/?Company_id=${Company_id}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      console.log('res', res);
      success(res.data);
    }, err => {
      console.log('err', err);
    })
}


const modalStyle = {
  width: '1200px',
  height: '750px',
  marginLeft: '-28%',
  marginTop: '-18%',
}

const propTypes = {
  setModalVisibility: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
}

const defaultProps = {
  setModalVisibility: () => { },
  isVisible: false,
}


const ToolTipFormatter = React.createClass({
  render() {
    return (
      <span data-tip data-for={this.props.dependentValues.PromotionLine_id}>
        { this.props.value }
      </span>
    );
  },
});

const AutoApplyFormatter = React.createClass({
  render() {
    return (
      <span>
        {
          (this.props.value)
            ? 'Yes'
            : 'No'
        }
      </span>
    );
  },
});

const OneTimeFormatter = React.createClass({
  render() {
    return (
      <span>
        {
          (this.props.value)
            ? 'Yes'
            : 'No'
        }
      </span>
    );
  },
});




const productPromotionColumns = [
  {
    key: 'ProductNum',
    name: <Translate value="prod_num" />,
    resizable: true,
    sortable: true,
    width: 100,
    filterable: true,
  },
  {
    key: 'RefNum',
    name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
    resizable: true,
    sortable: true,
    width: 90,
    filterable: true,
  },
  {
    key: 'PromoCode',
    name: <Translate value="code" />,
    resizable: true,
    sortable: true,
    width: 90,
    filterable: true,
  },
  {
    key: 'SalesType',
    name: <Translate value="sales_type" />,
    resizable: true,
    sortable: true,
    width: 100,
    filterable: true,
  },
  {
    key: 'AutoApply',
    name: <Translate value="auto" />,
    resizable: true,
    sortable: true,
    width: 70,
    filterable: true,
    formatter: AutoApplyFormatter,
    getRowMetaData: row => row,
  },
  {
    key: 'Name',
    name: <Translate value="name" />,
    resizable: true,
    sortable: true,
    width: 200,
    filterable: true,
  },
  {
    key: 'Description',
    name: <Translate value="description" />,
    resizable: true,
    sortable: true,
    width: 150,
    filterable: true,
  },
  {
    key: 'GroupName',
    name: <Translate value="customer" />,
    resizable: true,
    sortable: true,
    width: 90,
    filterable: true,
  },
  {
    key: 'DiscountDescription',
    name: <Translate value="discount_description" />,
    resizable: true,
    sortable: true,
    filterable: true,
    width: 270,
    formatter: ToolTipFormatter,
    getRowMetaData: row => row,
  },
  {
    key: 'RelatedQuantity',
    name: <Translate value="gift_quantity_column" />,
    resizable: true,
    sortable: true,
    width: 70,
    filterable: true,
  },
  {
    key: 'StartDate',
    name: <Translate value="start_date" />,
    resizable: true,
    sortable: true,
    filterable: true,
    width: 110,
    formatter: DateFormatter,

  },
  {
    key: 'EndDate',
    name: <Translate value="end_date" />,
    resizable: true,
    sortable: true,
    filterable: true,
    width: 100,
    formatter: DateFormatter,
  },
];

const byQuantityDiscountColumns = [
  {
    key: 'ProductNum',
    name: <Translate value="prod_num" />,
    resizable: true,
    sortable: true,
    width: 100,
    filterable: true,
  },
  {
    key: 'RefNum',
    name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
    resizable: true,
    sortable: true,
    width: 90,
    filterable: true,
  },
  {
    key: 'Name',
    name: <Translate value="name" />,
    resizable: true,
    sortable: true,
    width: 200,
    filterable: true,
  },
  {
    key: 'Description',
    name: <Translate value="description" />,
    resizable: true,
    sortable: true,
    width: 150,
    filterable: true,
  },
  {
    key: 'GroupName',
    name: <Translate value="customer" />,
    resizable: true,
    sortable: true,
    width: 90,
    filterable: true,
  },
  {
    key: 'DiscountDescription',
    name: <Translate value="discount_description" />,
    resizable: true,
    sortable: true,
    filterable: true,
    width: 270,
    formatter: ToolTipFormatter,
    getRowMetaData: row => row,
  },
  {
    key: 'StartDate',
    name: <Translate value="start_date" />,
    resizable: true,
    sortable: true,
    filterable: true,
    width: 110,
    formatter: DateFormatter,

  },
  {
    key: 'EndDate',
    name: <Translate value="end_date" />,
    resizable: true,
    sortable: true,
    filterable: true,
    width: 100,
    formatter: DateFormatter,
  },
];

const byTotalPriceDiscountColumns = [
  {
    key: 'PromoCode',
    name: <Translate value="code" />,
    resizable: true,
    sortable: true,
    width: 90,
    filterable: true,
  },
  {
    key: 'AutoApply',
    name: <Translate value="auto" />,
    resizable: true,
    sortable: true,
    width: 70,
    filterable: true,
    formatter: AutoApplyFormatter,
    getRowMetaData: row => row,
  },
  {
    key: 'IsOneTime',
    name: <Translate value="one_time" />,
    resizable: true,
    sortable: true,
    width: 70,
    filterable: true,
    formatter: OneTimeFormatter,
    getRowMetaData: row => row,
  },
  {
    key: 'SalesType',
    name: <Translate value="sales_type" />,
    resizable: true,
    sortable: true,
    width: 100,
    filterable: true,
  },
  {
    key: 'GroupName',
    name: <Translate value="customer" />,
    resizable: true,
    sortable: true,
    width: 90,
    filterable: true,
  },
  {
    key: 'PaymentType',
    name: <Translate value="payment_method" />,
    resizable: true,
    sortable: true,
    width: 200,
    filterable: true,
  },
  {
    key: 'DiscountDescription',
    name: <Translate value="discount_description" />,
    resizable: true,
    sortable: true,
    filterable: true,
    width: 260,
  },
  {
    key: 'StartDate',
    name: <Translate value="start_date" />,
    resizable: true,
    sortable: true,
    filterable: true,
    width: 110,
    formatter: DateFormatter,
  },
  {
    key: 'EndDate',
    name: <Translate value="end_date" />,
    resizable: true,
    sortable: true,
    filterable: true,
    width: 100,
    formatter: DateFormatter,
  },
];

const getColumns = (tabsKey) => {
  if (tabsKey === 'ByTotalPriceDiscount') {
    return byTotalPriceDiscountColumns;
  }
  if (tabsKey === 'ByTotalPriceProduct') {
    return productPromotionColumns;
  }
  return byQuantityDiscountColumns;
};


class Promotions extends Component {
  state = {
    activeKey: 'ByQuantity',
    promotions: [],
  }

  componentDidMount() {
    this.initialPromotions();
  }

  initialPromotions = () => {
    const success = ({ promotions }) => {
      this.setState({
        promotions,
      })
    }
    const failed = () => {
      console.log('faield');
    }
    fetchPromotions(this.props.selectedCompany.value, success, failed);
  }

  handleCloseClick = () => {
    this.props.setModalVisibility();
  }

  handleTabSelect = (activeKey) => {
    this.setState({ activeKey })
  }


  renderPromotionsTable = () => {
    const promotions = _.filter(this.state.promotions, p => {
      return p.Method === this.state.activeKey
    });
    const getRows = () => Data.Selectors.getRows({ rows: promotions });
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };
  
    return (
      <Row>
        <Col xs={12}>
          <ReactDataGrid
            rowKey="Product_id"
            columns={getColumns(this.state.activeKey)}
            rowHeight={25}
            headerRowHeight={45}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            toolbar={<Toolbar enableFilter />}
            minHeight={500}
          />
        </Col>
      </Row>
    )
  }
  render() {
    const byQuantityTitle = (<Translate value="by_quantity_discount" />);
    const buyAGetBTitle = (<Translate value="by_quantity_product" />);
    const byTotalPriceProductTitle = <span>
      <Translate value="by_total_price" /> (<Translate value="product" />)
    </span>
    const byTotalPriceDiscountTitle = (
      <span>
        <Translate value="by_total_price" /> (<Translate value="discount" />)
      </span>
    );
    return (
      <div style={{ width: '100%', height: '100%', padding: '10px' }}>
        <Tabs activeKey={this.state.activeKey} justified onSelect={this.handleTabSelect}>
          <Tab eventKey="ByQuantity" title={byQuantityTitle}>
            
          </Tab>
          <Tab eventKey="BuyAGetB" title={buyAGetBTitle}>
            {/* buyAGetB */}
          </Tab>
          <Tab eventKey="ByTotalPriceProduct" title={byTotalPriceProductTitle}>
            {/* byTotalPriceProduct */}
          </Tab>
          <Tab eventKey="ByTotalPriceDiscount" title={byTotalPriceDiscountTitle}>
            {/* byTotalPriceDiscount */}
          </Tab>
          {this.renderPromotionsTable()}
        </Tabs>
        <div style={{ position: 'absolute', bottom: '30px', right: '20px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            // disabled={selectedRows.length !== 1}
            onClick={() => {
              this.handleCloseClick();
            }}
          >
            {/* <em className="fa fa-pencil" /> */}
            <Translate value="close" />
          </Button>
        </div>
      </div>
    )
  }
}

const PromotionsModal = ({ setModalVisibility, isVisible, selectedCompany }) => (
  <SkyLightStateless
    title={<Translate value="promotion_list" />}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <Promotions setModalVisibility={setModalVisibility} isVisible={isVisible} selectedCompany={selectedCompany} />
  </SkyLightStateless>
)

PromotionsModal.propTypes = propTypes
PromotionsModal.defaultProps = defaultProps

export default PromotionsModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/PromotionsModal.jsx